import { Injectable } from '@angular/core';
import { fallbackString } from 'src/app/helpers/type-helpers';
import { IAdapter } from 'src/app/models';
import { TaskListCharacteristic } from 'src/app/models/domain/task-list-characteristic';
import { YPMTASKLISTSRVCharacteristics } from 'src/generated-clients/tasklist';

@Injectable({
  providedIn: 'root',
})
export class TaskListCharacteristicAdapter implements IAdapter<
  TaskListCharacteristic,
  YPMTASKLISTSRVCharacteristics
> {
  public adaptToDomain(item: YPMTASKLISTSRVCharacteristics): TaskListCharacteristic {
    return new TaskListCharacteristic(
      fallbackString(item.taskListType),
      fallbackString(item.taskListGroup),
      fallbackString(item.groupCounter),
      fallbackString(item.nodes),
      fallbackString(item.characteristic),
      fallbackString(item.counter),
      fallbackString(item.inspectionMethodPlant),
      fallbackString(item.pmtVersion),
      Boolean(item.refMasterInspectionCharacteristic),
      fallbackString(item.plant),
      fallbackString(item.mkVersion),
      fallbackString(item.weighting),
      fallbackString(item.shortText),
      fallbackString(item.sampleUnit),
      fallbackString(item.infoField1),
      fallbackString(item.infoField2),
      fallbackString(item.infoField3),
      fallbackString(item.shortTextSampleProcedure),
      fallbackString(item.shortTextInspectionCharacteristic),
      fallbackString(item.unitOfMeasure),
      fallbackString(item.baseSampleQuantity),
      fallbackString(item.client),
      fallbackString(item.masterInspectionCharacteristics),
      Boolean(item.longTextExists),
      fallbackString(item.language),
      fallbackString(item.samplingProcedure),
      item.targetValue,
      item.upperLimit,
      item.lowerLimit,
      item.decimalPlaces,
      item.firstUpperLimit,
      item.firstLowerLimit
    );
  }
}
